import type { FC } from 'react'
import { Address } from 'framework/address'
import { User } from 'framework/users'
import { useUserSession, useNotification } from 'hooks'
import { CustomerService } from 'modules/customers/services'
import { AddressService } from 'modules/address/services'
import { AddressForm } from 'modules/address/components'
import type { AddressEditorProps } from '.'

const AddressEditor: FC<AddressEditorProps> = ({
  onSuccess,
  recipient,
  address = null as unknown as Address,
  defaultZipCode = "",
  onCancel,
}) => {
  const { notify } = useNotification()
  const { user } = useUserSession()

  const onSubmit = async (data: any) => {
    try {
      const id = address?.id || null

      const customerService = new CustomerService(user as User)
      const addressService = new AddressService()
      addressService.setCustomerId(customerService.getCustomer()?.id || '')

      const dataAddresses = await addressService.list();
      console.log(dataAddresses)
      let noHasBIllingAddress = false;

      const addresses: any = dataAddresses.data?.addresses;

      if(!addresses.billing_address) {
        noHasBIllingAddress = true;
      }

      const payload = {
        recipient: data.recipient,
        type: noHasBIllingAddress ? "COBRANCA" : data.type,
        surname: 'Minha casa',
        city_id: data.city_id,
        street: data.street,
        postal_code: data.zipCode,
        number: data.number || '0',
        neighborhood: data.neighborhood,
        complement: data.complement || ' ',
      }

      if (id) {
        await addressService.updateAddressById(address?.id, payload as unknown as Address)
      } else {
        console.log("endereco criado", payload)
        await addressService.createAddress(payload as unknown as Address)
      }

      notify({
        title: 'Sucesso',
        description: id ? 'Endereço atualizado' : 'Endereço criado com sucesso',
        type: 'success',
      })
      if (typeof onSuccess === 'function') {
        onSuccess({
          ...address,
          ...payload,
          ...data,
          city: {
            id: data.city_id,
            name: data.city,
            district: data.district,
          },
        } as Address)
      }
    } catch (e) {
      notify({
        title: 'Atenção',
        description: `Houve um erro ao ${address?.id ? 'atualizar' : 'cadastrar'} seu endereço`,
        type: 'danger',
      })
    }

    return false
  }

  return <AddressForm recipient={recipient} onSubmit={onSubmit} address={address} onCancel={onCancel} defaultZipCode={defaultZipCode} />
}

export default AddressEditor
